import React from "react";
import { Button } from "../../general/Button/Button";
import { ButtonWithLoader } from "../../general/ButtonWithLoader/ButtonWithLoader";
import { FinancialDocument } from "../../../common/types/financialDocument";
import { useDownloadFinancialDocumentFile } from "./useDownloadFinancialDocumentFile";
import styles from "./FinancialDocumentDetailsHeader.module.scss";
import { useFinancialDocumentDetailsContext } from "./financialDocumentDetails.context";
import { FinancialDocumentDetailsView } from "./usePathBasedFinancialDocumentDetailsView";

interface FinancialDocumentNoMatchesProps {
    financialDocument: FinancialDocument;
}

export const FinancialDocumentNoMatches: React.FC<
    FinancialDocumentNoMatchesProps
> = ({ financialDocument }) => {
    const { changeView } = useFinancialDocumentDetailsContext();
    const { download, downloading } =
        useDownloadFinancialDocumentFile(financialDocument);

    return (
        <>
            <p className="text-gray-700">
                If this is a receipt, find a transaction.
            </p>
            <footer className={styles.noMatchesActions}>
                <ButtonWithLoader
                    variant="secondary"
                    onClick={download}
                    loading={downloading}
                >
                    Download
                </ButtonWithLoader>
                <Button
                    variant="default"
                    onClick={() =>
                        changeView(FinancialDocumentDetailsView.MATCHING)
                    }
                    data-testid="financial-document-no-matches-find-transaction-button"
                >
                    Find a transaction
                </Button>
            </footer>
        </>
    );
};
